import { render } from "./ImagePolygonOutline.vue?vue&type=template&id=f731a58c&scoped=true&ts=true"
import script from "./ImagePolygonOutline.vue?vue&type=script&lang=ts"
export * from "./ImagePolygonOutline.vue?vue&type=script&lang=ts"

import "./ImagePolygonOutline.vue?vue&type=style&index=0&id=f731a58c&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f731a58c"]])

export default __exports__